/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-popup-trigger-factory.ts to modify the generation of this file.

import { TimerTrigger } from 'src/helpers/PopupTriggers/Triggers/TimerTrigger';

import { IBasePopupTrigger } from 'src/helpers/PopupTriggers/BasePopupTrigger';

type PopupTriggerConstructor = new ({
  triggerFieldsProps,
}: {
  triggerFieldsProps: unknown;
}) => IBasePopupTrigger;

const triggers = new Map<string, PopupTriggerConstructor>();

triggers.set('timertrigger', TimerTrigger);

export type PopupTriggerItem = {
  templateName?: string;
  name?: string;
  displayName?: string;
  fields?: unknown;
};

export function popupTriggerFactory(trigger: PopupTriggerItem): IBasePopupTrigger | undefined {
  const triggerTemplateName = trigger?.templateName;
  const triggerKey = triggerTemplateName?.replaceAll?.(' ', '').toLowerCase();
  const triggerClass = triggerKey ? triggers.get(triggerKey) : undefined;

  if (!!triggerClass) {
    return new triggerClass({
      triggerFieldsProps: trigger.fields,
    });
  }

  console.error(`No trigger handler defined for ${triggerTemplateName}`);

  return undefined;
}
